import merge from '~lodash.mergewith'
import * as CoreSdk from '~@sentry/core'
import { captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } from '~@sentry/browser'
import { replayIntegration } from '~@sentry/browser'
import { extraErrorDataIntegration, reportingObserverIntegration, rewriteFramesIntegration } from '~@sentry/integrations'
import { init, browserTracingIntegration } from '~@sentry/vue'

export { init }
export const SentrySdk = { ...CoreSdk, ...{ captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } }

/** @type {string[]} */
const DISABLED_INTEGRATION_KEYS = []

/**
 * @typedef {Parameters<typeof init>[0]} InitConfig
 * @param {import('@nuxt/types').Context} ctx
 * @return {Promise<InitConfig>}
 */
export function getConfig (ctx) {
  /** @type {InitConfig} */
  const config = {
    dsn:"https:\u002F\u002Faf620fc131e94a228a8824060c5f9407@o488590.ingest.sentry.io\u002F5748755",
    environment:"production",
    release:"baldr@baldr-7.0.9",
    allowUrls:[new RegExp("https?:\\\u002F\\\u002F((cdn|www)\\.)?asphalte\\.com", ""),new RegExp("https?:\\\u002F\\\u002Fasphalte-(dev|preprod)\\.netlify\\.app", "")],
    denyUrls:[new RegExp("graph\\.facebook\\.com", "i"),new RegExp("connect\\.facebook\\.net\\\u002Fen_US\\\u002Fall\\.js", "i"),new RegExp("extensions\\\u002F", "i"),new RegExp("^chrome:\\\u002F\\\u002F", "i")],
    beforeSend:function(event, hint) {
            const error = hint.originalException;

            if (
            error &&
            error.message && (
            error.message.includes(
              'Deprecation messages are stored in the devtools-frontend repo'
            ) ||
            error.message.match(
              /Deprecation messages are stored in the devtools-frontend repo/i
            )))
            {
              return null;
            }

            const isNonErrorException =
            event.exception &&
            event.exception.values[0].value.startsWith('Non-Error') ||
            hint.originalException &&
            hint.originalException.message &&
            hint.originalException.message.startsWith('Non-Error');

            if (isNonErrorException) {
              // We want to ignore those kind of errors
              return null;
            }

            return event;
          },
    replaysSessionSampleRate:0.1,
    replaysOnErrorSampleRate:1,
    tracesSampleRate:0.1,
  }

  /** @type {NonNullable<InitConfig>['integrations']} */
  const resolvedIntegrations = [
    extraErrorDataIntegration(),
    reportingObserverIntegration({ types:["crash","crash"] }),
    rewriteFramesIntegration(),
    replayIntegration(),
  ]

  resolvedIntegrations.push(browserTracingIntegration({
    router: ctx.app.router,
    ...{"routeLabel":"name"},
    ...{},
  }))
  merge(config, {"trackComponents":true}, {"tracesSampleRate":0.1})

  config.integrations = (defaultIntegrations) => {
    return [
      ...defaultIntegrations.filter(integration => !DISABLED_INTEGRATION_KEYS.includes(integration.name)),
      ...resolvedIntegrations,
    ]
  }
  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
